// import React, { useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { changeStatusOrCostPerClick } from '../../redux/actions/bidding';
// import Button from '../shared/button';
// import WalletInput from './bidding-input';
import "./bidding-styles.scss";

interface Props {
  balance: string;
  status: boolean;
}

const BiddingBalanceAlert = ({ balance, status }: Props) => {
  const balanceFlag = Number(balance) > 0;

  return (
    <div className="mt-6 text-sm font-medium ">
      <div className="flex justify-between">
        {!status && !balanceFlag && (
          <div className="flex px-3 py-2 mt-4 bg-pkc-red-15 !border-2 !border-pkc-red !text-pkc-red rounded-md shadow">
            <div className="flex justify-center mt-2 text-sm font-medium ">
              <p>
                بودجه ی شما برای فعال سازی طرح افزایش بازدید کمتر از قیمت یک کلیک می باشد. لطفا بودجه خود را افزایش
                دهید.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BiddingBalanceAlert;
